import {useState} from "react";
import {TimeSpan} from "@sparkware/app-utils";
import {Button} from "../../basic-ui-components/button/base/button.component";
import {useServices} from "../../react-hooks/use-services.hook";
import {GamblingSessionLimitReachedComponent, LimitType} from "../gambling-session/limit-reached/gambling-session-limit-reached.component";
import {DropDownComponent} from "../gambling-session/setup/parts/drop-down.component";
import {GamblingSessionSetupComponent} from "../gambling-session/setup/gambling-session-setup.component";
import {IGamblingSessionLimitsSetup} from "../../services/gambling-session/gambling-session-limits-setup.interface";
import {GamblingSessionLogoutDialog} from "../gambling-session/logout/gambling-session-logout-dialog.component";

enum GamblingSessionDialog {
    Setup = 1,
    IntervalReminder,
    LimitReached,
    Logout
}

export const GamblingSessionSetupDialogShowcase: React.FC = () => {
    const services = useServices();
    const [dialogType, setDialogType] = useState(GamblingSessionDialog.Setup);
    const onSetLimits = (limits: IGamblingSessionLimitsSetup) => {
        alert(JSON.stringify(limits));
    };
    // window.TimeSpan = TimeSpan;
    const toggleOpen = () => {
        switch (dialogType) {
            case GamblingSessionDialog.Setup:
                services.dialog.showModal(dialogHandler => (<GamblingSessionSetupComponent
                    dialogHandler={dialogHandler}
                    onSetLimits={onSetLimits}
                    // onContinue={onContinue}
                />), {
                    title: services.translation.translate('GAMBLING_SESSION_SETUP_TITLE'),
                    isHighPriority: true,
                    mobileCenterHeader: true,
                    // onClosedByXButton: () => resolve(GameStepsExecutionResultEnum.Cancel),
                    // renderExtraHeaderButtons: () => <HelpPageButtonComponent/>
                });
                break;
            case GamblingSessionDialog.IntervalReminder:
                services.dialog.showModal(dialogHandler => (<GamblingSessionLimitReachedComponent
                    dialogHandler={dialogHandler}
                    sessionDuration={TimeSpan.fromMinutes(75)}
                    limitType={LimitType.IntervalReminder}
                    totalBets={25}
                    totalWins={-25000}
                    
                    sessionLimitTimestamp="poimierți"
                />), {
                    title: services.translation.translate('GAMBLING_SESSION_INTERVAL_REMINDER_TITLE'),
                    noDefaultContentPadding: true,
                    isHighPriority: true,
                    mobileCenterHeader: true,
                });
                break;
            case GamblingSessionDialog.LimitReached:
                services.dialog.showModal(dialogHandler => (<GamblingSessionLimitReachedComponent
                    dialogHandler={dialogHandler}
                    sessionDuration={TimeSpan.fromMinutes(75)}
                    limitType={LimitType.Loss}
                    totalBets={25}
                    totalWins={-25000}
                    
                    sessionLimitTimestamp="poimierți"
                />), {
                    title: services.translation.translate('GAMBLING_SESSION_LOSS_LIMIT_REACHED_TITLE'),
                    noDefaultContentPadding: true,
                    isHighPriority: true,
                    mobileCenterHeader: true,
                });
                break;
            case GamblingSessionDialog.Logout:
                services.dialog.showModal((dialogHandler) => (
                    <GamblingSessionLogoutDialog
                        dialogHandler={dialogHandler}
                        sessionDuration={TimeSpan.fromMinutes(25)}
                        totalBets={43}
                        totalWins={156}
                        onLogout={() => {
                            dialogHandler.close();
                        }}
                        onCancel={() => {
                            dialogHandler.close();
                        }}
                    />
                ), {
                    title: services.translation.translate("GAMBLING_SESSION_LOGOUT_DIALOG_TITLE"),
                    noDefaultContentPadding: true,
                    isHighPriority: true,
                    mobileCenterHeader: true,
                    // onClosedByXButton: () => {}
                });
                break;
            default:
                break;
        }
    };
    return (<div style={{padding: "5px 2rem", display: "flex"}}>
        <div style={{width: "300px"}}>
        <DropDownComponent
            label="Gambling Session Dialog Select"
            items={[{
                value: GamblingSessionDialog.Setup,
                text: "Setup Dialog"
            }, {
                value: GamblingSessionDialog.IntervalReminder,
                text: "Interval Reminder"
            }, {
                value: GamblingSessionDialog.LimitReached,
                text: "Limit Reached"
            }, {
                value: GamblingSessionDialog.Logout,
                text: "Logout"
            }]}
            onItemSelected={(value: GamblingSessionDialog) => {
                setDialogType(value);
                return Promise.resolve({
                    cancel: false
                });
            }}
            className="showcase-gambling-session-dialog-select"
        />
        </div>
        <Button preset="info" onClick={toggleOpen} margin="2rem 0 0 2rem">Show game limits popup</Button>
    </div>);
}